import RightContent from "../../components/OnBoard/RightContent";
import OrderedList from "../../components/OnBoard/Menu";
import cogoToast from "cogo-toast-react-17-fix";
import styles from "./UserOnboarding2.module.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Icon } from 'react-icons-kit'
import { ic_content_copy } from 'react-icons-kit/md/ic_content_copy';
import { ic_file_download } from 'react-icons-kit/md/ic_file_download'
import Error from "../../components/OnBoard/Error";
import API from "../../ApiConfig";
import { BASE_URL, GET_KEYPAIR } from "../../Utils/constant";

const UserOnboarding2 = () => {
  const userData = JSON.parse(localStorage.getItem("user_data"));
  if (userData == null) {
    return (<Error Message={"Some Error Occured"} />);
  }

  const navigate = useNavigate();
  const [generate, setGenerate] = useState(false);
  const [privateKey, setPrivateKey] = useState("Private Key");
  const [publicKey, setPublicKey] = useState("Public Key");
  const [isLoading, setIsLoading] = useState(false);

  const copy = (value) => {
    navigator.clipboard.writeText(value);
    cogoToast.info("Copied")
  }

  const verify = () => {
    navigate("/app/registration/step3");
  }

  const getKeys = () => {
    setGenerate(true);
    setIsLoading(true); // Set loading state to true
    fetch(BASE_URL + GET_KEYPAIR + userData.id)
      .then(response => response.json())
      .then(data => {
        if (data.success == true) {
          setPrivateKey(data.data.private_key);
          setPublicKey(data.data.public_key);
        } else {
          if (data.message.includes("UNIQUE")) {
            cogoToast.info("Key already generated");
            verify();
          } else {
            cogoToast.error("Failed to Generate keys");
          }
          setGenerate(false);
        }
      })
      .catch(err => {
        cogoToast.error("Failed to Generate keys");
        setGenerate(false);
      })
      .finally(() => {
        setIsLoading(false); // Reset loading state
      });
  }

  const downloadTextFile = (keys, name) => {
    const blob = new Blob([keys], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = name + '.pem';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className={styles.userOnboarding}>
      <RightContent />
      <section className={styles.leftContent}>
        <div className={styles.progressForm}>
          <div className={styles.progressForm1}>
            <OrderedList pos="3" />
            <div className={styles.form}>
              <div className={styles.form1}>
                <div className={styles.headingHelperText}>
                  <h3 className={styles.heading}>Generate private key</h3>
                  <div className={styles.supportingText}>
                    Generate and keep private key in safe place
                  </div>
                </div>
              </div>
              {generate &&
                <>
                  <div className={styles.inputField1}>
                    <div className={styles.label1}><span style={{display:"flex",alignItems:"center"}}>Private key</span>
                    <div>
                    <span onClick={() => copy(privateKey)} className={styles.copyIcon}><Icon icon={ic_content_copy} size={20} title="Copy" /></span>
                    <span onClick={() => downloadTextFile(privateKey, userData.name + "_private")} className={styles.copyIcon}><Icon icon={ic_file_download} size={20} title="Download Private Key" /></span>
                    </div>
                    </div>
                    <div className={styles.input1}>
                      <textarea className={styles.insideInput} id={styles.Scrollbar} value={privateKey} readOnly rows={3} />
                    </div>
                  </div>
                  <div className={styles.inputField1}>
                    <div className={styles.label1}>
                      <span style={{display:"flex",alignItems:"center"}}>Public Key</span>
                      <div>
                      <span onClick={() => copy(publicKey)} className={styles.copyIcon}><Icon icon={ic_content_copy} size={20} title="Copy"/></span>
                      <span onClick={() => downloadTextFile(publicKey, userData.name + "_public")} className={styles.copyIcon}><Icon icon={ic_file_download} size={20} title="Download Public Key"/></span>
                      </div>
                    </div>
                    <div className={styles.input1} id={styles.Scrollbar}>
                      <textarea className={styles.insideInput} id={styles.Scrollbar} value={publicKey} readOnly rows={3} />
                    </div>
                  </div>
                </>
              }
            </div>
          </div>
        </div>
        <footer className={styles.buttonHelperText}>
          {generate ?
            <button className="primaryBtn" onClick={verify} disabled={isLoading}>
              {isLoading ? "Generating Keys..." : "Submit"}
            </button> :
            <button className="primaryBtn" onClick={getKeys} disabled={isLoading}>
              {isLoading ? "Generating..." : "Generate private key"}
            </button>}
        </footer>
      </section>
    </div>
  );
};

export default UserOnboarding2;
